<script>
export default {
  name: "DescriptionListItem",
  props: {
    term: {
      type: String,
      required: true,
    },
    details: {
      type: String,
    },
    to: {
      type: Object,
    },
    truncated: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    getDetails() {
      return this.details ?? this.$t('common.na');
    }
  },
}
</script>

<template>
  <div :class="{'truncated':truncated}">
    <dt>{{ term }}</dt>
    <dd v-if="!to">
      <slot>{{ getDetails }}</slot>
    </dd>

    <dd v-else>
      <router-link class="transition-all inline-flex hover:underline underline-offset-2 text-blue-600" :to="to">
        {{ getDetails }}
      </router-link>
    </dd>
  </div>
</template>

<style scoped>
div {
  @apply flex justify-between items-start py-3 text-sm font-medium space-x-3;
}

dt {
  @apply text-gray-500;
}

dd {
  @apply text-gray-900;
}

.truncated dd {
  @apply truncate;
}
</style>